<template>
  <v-card>
    <v-toolbar dark color="primary" tabs>
      <v-btn icon dark @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ $t('Datos del formulario') }}</v-toolbar-title>
    </v-toolbar>

    <v-card-text>
      <lopd-data-wizard-view
        :key="entity.id"
        v-if="configReady"
        :config="config"
        :entity="entity"
        @close="close()"
      ></lopd-data-wizard-view>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="close()">
        {{ $t('Cerrar') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import LopdDataWizardView from './LopdDataWizardView';
import apiCtrl from '@/services/aru-services/aru-api.service.js';

export default {
  components: {
    LopdDataWizardView,
  },
  props: {
    entity: {
      type: Object,
    },
  },
  data() {
    return {
      configReady: false,
      config: null,
    };
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    close() {
      this.$emit('close');
    },
    getConfig() {
      this.configReady = false;
      apiCtrl.get('/config/opendata').then(res => {
        this.config = res.data.data;
        this.configReady = true;
      });
    },
  },
};
</script>

<style></style>
